import { observer } from "mobx-react";
import styles from "./styles/StaffCard.module.scss";
import { UserAvatar } from "../../../utilities/UserAvatar";

const StaffCard = observer(
  (props: { staff: IUser; personBlockObj: IPersonBlock }) => {
    return (
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <UserAvatar
            avatarUrl={props.personBlockObj.blockModel.avatarUrl}
            fname={props.staff.fname}
            lname={props.staff.lname}
            size="8"
            avatarProps={{ className: styles.avatar }}
          />
        </div>
        <div className={styles.staffName}>
          <span>{props.staff.fname} </span>
          <span>{props.staff.lname}</span>
        </div>
        <div className={styles.staffTitle}>{props.staff.title}</div>
      </div>
    );
  },
);

export default StaffCard;
